module.exports = __webpack_public_path__ + "assets/img/people-1.a8c5cb8f.png";